export { default } from "./ImageQuestionCard"